import { StyledSkipLink } from 'ui/skip-link/skip-link.styles';
import type { SkipLinkProps } from 'ui/skip-link/skip-link.types';

const SkipLink = ({
  targetId = 'main-content',
  children = 'Skip to main content',
}: SkipLinkProps) => (
  <StyledSkipLink href={`#${targetId}`}>{children}</StyledSkipLink>
);

export default SkipLink;
